<template>
  <div>
    <popover-right class="cus-detail-popover-style" width="1045px" v-model="isShowCustomerDetail" :closed="cancel">
      <p class="toggle-btn" v-if="condition">
        <i class="iconfont iconarrowleft toggle-btn-item" :class="isFirstPage() ? 'disabled' : ''" @click="toggleVisitor('prev')"></i>
        <i class="iconfont iconarrowright toggle-btn-item" :class="isLastPage() ? 'disabled' : ''" @click="toggleVisitor('next')"></i>
      </p>
      <div class="base-info">
        <div class="header-area">
          <div class="level-style" :style="{backgroundColor: getLevelColor}">
            <portia :avatar="userInfo.avatar" customeClass="level" :isNeedFix="false" v-if="userInfo.avatar" />
            <p class="level-big" v-else-if="userInfo.level != 99">{{options.customer_levels && options.customer_levels[userInfo.level] || '--'}}</p>
            <p class="level-small" v-else>未知</p>
          </div>
          <div class="flexAll pd20">
            <div class="user-card">
              <el-popover placement="top-start" title="" width="250" trigger="hover" v-if="userInfo.lock_status === 1">
                <div>
                  <p> 客户已锁定</p>
                  <p class="custome-jiesuo-date">解锁日期:<span v-analysis-time:all="userInfo.lock_time_end"></span></p>
                </div>
                <i class="iconfont card-lock iconsuoding1 lock-event" @click="confirmCancelLock" slot="reference" v-if="isAllowUnLock"></i>
                <i class="iconfont card-lock iconsuoding1" v-else></i>
              </el-popover>
              <i class="iconfont card-lock iconjiesuo1 lock-event" @click="handleCommand('lock')" v-else-if="isAllowLock"></i>
              <i class="iconfont card-lock iconjiesuo1" v-else></i>

              <h1 class="card-title">{{userInfo.name || '--'}}</h1>
              <p class="wechat-card" v-if="userInfo.wework_customer_id > 0">
                <span>@{{userInfo.wework_type === 1 ? '微信' : userInfo.wework_corp_name}}</span>
                <template v-if="userInfo.wework_gender !== 0">
                  <i class="iconfont iconman" :class="userInfo.wework_gender === 1 ? 'iconman' : userInfo.wework_gender === 2 ? 'iconnv' : ''"></i>
                </template>
              </p>
              <p class="wechat-card wechat-card-visited" v-if="userInfo.shop_visitor_id > 0">
                <span>@云门店访客</span>
                <template v-if="userInfo.shop_visitor_gender !== 0">
                  <i class="iconfont iconnv" :class="userInfo.shop_visitor_gender === 1 ? 'iconman' : userInfo.shop_visitor_gender === 2 ? 'iconnv' : ''"></i>
                </template>
              </p>

            </div>
            <div class="concat-card">
              <p class="concar-item-style">{{userInfo.contact_tel || ''}}</p>
              <p class="concar-item-style" v-if="userInfo && userInfo.relation_customer && userInfo.relation_customer.length > 0">
                合并客户：
                <template v-for="(user, i) in userInfo.relation_customer">
                  {{i != 0 ? '、' : ''}}
                  <span class="concar-item-label"  @click="toConcatDetail(user)" :key="`concat_${user.id}`">{{user.name}}</span>
                </template>
              </p>
              <p class="concar-item-style">现负责人：{{principalName}}</p>
              <p class="concar-item-style ml10" v-if="helpsName">协助人：{{helpsName}}</p>
            </div>
          </div>
          <div class="info-btn-list">
            <!-- 协助人状态 -->
            <el-dropdown @command="handleHelpCommand" v-if="userInfo.allow_helper_add || userInfo.allow_helper_cancel || userInfo.allow_helper_exit">
              <el-button size="mini" class="mr10">协助人</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="add" v-if="userInfo.allow_helper_add">新增协助人</el-dropdown-item>
                <el-dropdown-item command="remove" v-if="userInfo.allow_helper_cancel">移除协助人</el-dropdown-item>
                <el-dropdown-item command="out" v-if="userInfo.allow_helper_exit">退出协助人</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button size="mini" class="btn-edit" @click="activeName = 'base'" v-if="userInfo.allow_edit">编辑</el-button>
            <el-button size="mini" class="btn-follow" @click="toFollow" v-if="userInfo.allow_follow_up">写跟进</el-button>
            <el-button size="mini" class="btn-follow" @click="handleGuestDistribe([{id: userInfo.id}])" v-if="userInfo.allow_distribution" v-permission="'customer.new.list.distribute'">分配</el-button>
            <el-button size="mini" class="btn-follow" @click="handleQiangDistribe()" v-if="userInfo.status == 5" v-permission="'customer.new.list.loot'">抢客</el-button>
            <el-dropdown  @command="handleCommand" v-if="isAllowToPublic || isAllowToInvalid || isAllowToBlack">
              <el-button size="mini" class="ml10">放弃</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="publicPool" v-if="isAllowToPublic">公客池</el-dropdown-item>
                <el-dropdown-item command="invalid" v-if="isAllowToInvalid">无效池</el-dropdown-item>
                <el-dropdown-item command="blackList" v-if="isAllowToBlack">黑名单</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
        </div>
        <div class="cus-approve-style">
          <template v-if="userInfo.nodes && userInfo.nodes.length > 0">
            <div class="step" v-for="(flow, key) in userInfo.nodes" :key="key" :class="flow.is_use===1 && 'active'" @click="handleNodeEvent(flow)">
              <p class="approve-text">{{flow.name}}</p>
              <p class="approve-time" v-analysis-time:date="flow.time" v-if="flow.time"></p>
            </div>
          </template>
        </div>
      </div>
      <div class="base-br"></div>
      <el-tabs v-model="activeName" type="border-card" class="base-tab-style" :class="isHideTrack && 'base-tab-hide-track-style'" @tab-click="handleTabClick">
        <el-tab-pane name="journey" lazy>
          <span slot="label" title="在途天数：即客户进入系统的天数，=客户提交第一个认购订单并审批通过的日期 - 客户创建日期 + 1。举例：若客户 12 月1 日创建，12 月 2 日认购通过，当前是 12 月 3 日，在途天数 = 2-1 +1 = 2 天。">旅程（{{userInfo.route_total || 0}}天）</span>
          <detail-journey :customeId="customerId" :baseInfo="userInfo" :activeName="activeName" :activeType="customeFollowType" @handleUpdateRecord="handleUpdateRecord" ref="detailJourneyRef" />
        </el-tab-pane>
        <el-tab-pane name="preview" v-if="hasRecordTrack">
          <span slot="label" title="">浏览记录</span>
          <preview-record-list :customeId="customerId" :hasRecordTrack="hasRecordTrack" :closed="cancel" ref="detailPreviewRef" @hideTrackTab="hideTrackTab" @showTrackTab="showTrackTab" />
        </el-tab-pane>
        <el-tab-pane name="base" lazy>
          <span slot="label" title="完整程度：采用百分比的形式展示。= （已有信息的字段数 / 详细信息中所有字段数 ）*100%">详细资料（{{userInfo.completion_percent || 0}}%）</span>
          <custome-base-info  :baseInfo="userInfo" :customeId="customerId" :emitName="emitName" :activeName="activeName" :closed="cancel" :initCb="getCustomeById" ref="detailBaseRef" />
        </el-tab-pane>
        <el-tab-pane name="bussiness" lazy>
          <span slot="label" title="指从报备到带看的阶段">商机（{{userInfo.business_total || 0}}）</span>
          <bussiness-info :baseInfo="userInfo" :customeId="customerId" :emitName="emitName" :activeName="activeName" :closed="cancel" :initCb="getCustomeById" ref="detailBussiness" />
        </el-tab-pane>
        <el-tab-pane name="order" lazy>
          <span slot="label" title="指从认筹到签约的阶段">订单（{{userInfo.order_total || 0}}）</span>
          <order-info :baseInfo="userInfo" :customeId="customerId" :emitName="emitName" :activeName="activeName" :closed="cancel" :initCb="getCustomeById" ref="detailOrder" />
        </el-tab-pane>
      </el-tabs>
    </popover-right>
    <custome-move-out v-bind:model_id.sync="isOpenMoveOut" moveout_type="guest" @handleMoveout="handleMoveoutConfirm"></custome-move-out>
  </div>
</template>
<script>
import PopoverRight from '@/components/popover/index';
import {configKeys} from '@/setting/index';
import {userUnLock, getCustomByIdApi, setGuestDistribution, getPrivateCustome, myPublicCustomeList, outCustomeHasHelper,isPlatformTrack, guestTakeUser} from '@/api/custome';
import { mapState } from 'vuex';
import CustomeMoveOut from '../components/customeMoveOut';
import customeMixins from '../mixins/operate';
import { getPermission } from '@/utils/auth';
import DetailJourney from './journey';
import CustomeBaseInfo from './baseInfo';
import BussinessInfo from './bussinessInfo';
import OrderInfo from './orderInfo';
import PreviewRecordList from './previewRecord';
export default{
  name: 'CustomeDetail',
  mixins: [customeMixins],
  components: {
    PopoverRight,
    CustomeMoveOut,
    DetailJourney,
    CustomeBaseInfo,
    BussinessInfo,
    OrderInfo,
    PreviewRecordList
  },
  props: {
    value: String
  },
  data () {
    const params = this.$attrs?.bindParams ?? {};
    return {
      ...params,
      activeName: params.tabActiveName || 'journey',
      // activeName:'',
      condition: params.condition || null,
      userInfo: {},
      options: {},
      isOpenMoveOut: false,
      isHideTrack: false,
      customeFollowType:[params.journeyType],
      hasRecordTrack:false
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.user.userInfo
    }),
    getLevelColor () {
      if (this.userInfo.wework_customer_id > 0) return 'transparent';
      switch (Number(this.userInfo.level)) {
        case 1:
          return '#fe5400';
        case 2:
          return '#15b77e';
        case 3:
          return '#20adfd';
        case 4:
          return '#bbbbbb';
        case 99:
          return '#cccccc';
      }
    },
    isShowCustomerDetail () {
      return this.value === 'customerDetail' || this.value === 'customerDetailCopy';
    },
    // 用户允许锁定或已经提交审批且有审批权限
    isAllowLock () {
      return (this.userInfo.lock_status === 0 && this.userInfo.allow_lock || (!this.userInfo.allow_lock && this.userInfo.approval_lock_id !== 0)) && this.permissions?.['customer.detail.index.lock'];
    },
    // 解锁权限
    isAllowUnLock () {
      return this.userInfo.lock_status === 1 && this.userInfo.allow_unlock && this.permissions?.['customer.detail.unlock'];
    },
    // 进入公客池权限
    isAllowToPublic () {
      return this.userInfo.allow_shift_public && this.permissions?.['customer.detail.index.shift-public'];
    },
    // 用户允许转入无效或已经提交审批且有审批权限
    isAllowToInvalid () {
      return (this.userInfo.allow_shift_invalid || (!this.userInfo.allow_shift_invalid && this.userInfo.approval_invalid_id !== 0)) && this.permissions?.['customer.detail.index.shift-invalid'];
    },
    // 用户允许转入黑名单或已经提交审批且有审批权限
    isAllowToBlack () {
      return (this.userInfo.allow_shift_black || (!this.userInfo.allow_shift_black && this.userInfo.approval_black_id !== 0)) && this.permissions?.['customer.detail.index.shift-black'];
    },
    // 获取当前负责人姓名
    principalName () {
      if (this.currentUser.id === this.userInfo.admin_id) return '我';
      return this.userInfo.admin_name || '无';
    },
    // 显示的协助人
    helpsName () {
      if (this.userInfo?.helpers?.length > 0) {
        return this.userInfo.helpers.map(v => {
          if (this.currentUser.id === v.id) return '我';
          return v.name;
        }).join(',');
      }
      return null;
    }
  },
  async created () {
    this.permissions = {};
    this.permissionInitial();
    this.$EventBus.$on('bindUserInfo', this.bindUserInfo);
    if (this.condition) {
      this.getToggleList();
    }
    if(this.activeName == ''){
      this.activeName = this.tabActiveName ? this.tabActiveName : 'journey'
    }
  },
  async mounted() {
    this.options = await this.$store.dispatch('initConfig', [configKeys.customer_levels]);
    this.getCustomeById();
    this.hasRecordList(this.customerId);

  },
  methods: {
    async hasRecordList(id){
      try {
        const res = await isPlatformTrack({customer_id:id});
        this.hasRecordTrack = res == 1 ? true : false
      } catch (err) {
        this.$message.error(err.msg || '操作失败，请重试');
      }
    },
    hideTrackTab () {
      this.isHideTrack = true;
      // 切换到旅程
      if(this.activeName == 'preview'){
        this.activeName = 'journey'
      }
    },
    showTrackTab () {
      this.isHideTrack = false;
    },
    handleOperateReload (type) {
      // 分配成功直接关闭详情页并且刷新列表
      if (type === 'guest') {
        this.cancel();
      }
    },
    isLastPage () {
      const switchList = this.toggleList?.length ?? 0;
      return this.per_to === this.per_total && this.index === switchList - 1;
    },
    isFirstPage () {
      return this.condition?.page === 1 && this.index === 0;
    },
    permissionInitial () {
      const userRoles = getPermission();
      const dragPermission = ['customer.detail.index.lock', 'customer.detail.unlock', 'customer.detail.index.shift-public', 'customer.detail.index.shift-invalid', 'customer.detail.index.shift-black', 'customer.new.list.distribute'];
      dragPermission.map(v => {
        if (userRoles.indexOf(v) >= 0){
          this.permissions[v] = true;
        }
      })
    },
    handleNodeEvent (flow) {
      if (flow.is_use !== 1) return null;
      if (flow.id === 2) {
        this.activeName = 'journey';
      } else if (flow.id === 6 || flow.id === 7) {
        this.activeName = 'bussiness';
      } else if ([9, 10, 11].indexOf(flow.id) >= 0) {
        this.activeName = 'order';
      }
    },
    cancel () {
      this.$emit('input', '');
    },
    // 联系人详情-跳转
    toConcatDetail (user) {
      this.operateCheckRouter('customerDetail', {
        customerId: user.id
      })
    },
    // 写跟进-跳转
    toFollow () {
      this.operateCheckRouter('customerFollow', {
        customer_id: this.userInfo.id
      })
    },
    // 解锁Event
    confirmCancelLock () {
      this.$confirm('解锁后，该客户将受到公客池回收规则的限制，请确认是否解锁', '操作提示', {
        customClass: 'custom-delete-dialog'
      }).then(async _ => {
        try {
          const res = await userUnLock({
            customer_id:this.userInfo.id
          });
          this.$message.success('解锁成功');
          this.getCustomeById();
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
        }
      }).catch(e => {})
    },
    // 获取客户详情
    async getCustomeById () {
      try {
        const res = await getCustomByIdApi(this.customerId);
        this.userInfo = Object.assign({}, res, {
          room_id: res.room_id ? res.room_id.split(',').map(v => `${v}`) : [],
          house_type: res.type_id ? res.type_id.split(',').map(v => `${v}`) : [],
          label: res.labels || [],
          decoration: res.decoration_id ? res.decoration_id.split(',').map(v => `${v}`) : [],
          level: `${res.level}`,
          qualifications: `${res.qualifications}`,
          orientation: res.orientation?`${res.orientation}`:'',
          customer_name: res.name,
          customer_id: res.id,
          city_area_id: res.city_area_id ? res.city_area_id.split(',') : [],
          city_area_name: res.city_long_name_arr,
          intention_project_ids: res.intention_project_ids ? res.intention_project_ids.split(',') : [],

          intention_project_names: res.intention_project_names ? res.intention_project_names.split(',') : []
        });
         // 拼接意向项目
          const ids = this.userInfo.intention_project_ids || [];
          const names = this.userInfo.intention_project_names || [];
          if (ids.length > 0) {
            const idList = ids.map((v, i) => {
              return v == 0 ? names[i] : {id: Number(v), name: names[i]};
            })
            this.userInfo.intention_project_ids = idList;
          }
          //拼接意向区域
          const areaIds = this.userInfo.city_area_id || [] ;
          const areaNames = this.userInfo.city_area_name || [];
          if (areaIds.length > 0) {
            const areaIdList = areaIds.map((v, i) => {
              return v == 0 ? areaNames[i] : {id:  Number(v), name: areaNames[i]};
            })
            this.userInfo.city_area_id = areaIdList;
          }
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试')
      }
    },
    handleCommand (type) {
      this.operateCheckRouter('operate', {operateType: type});
    },
    // 协助人操作
    handleHelpCommand (type) {
      if (type === 'out') {
        this.outCustomHelper();
        return ;
      }
      const info = {
        customeId: this.customerId,
        customeName: this.userInfo.name,
        mobile: this.userInfo.contact_tel
      }
      this.$EventBus.$emit(this.emitName, {category: type === 'add' ? 'customeHelper' : 'customeHelperRemove', params: {
        type: 'new',
        tabActiveName: this.activeName,
        customeInfo: info
      }});
    },
    // 检查-跳转
    operateCheckRouter (typeName, conditions = {}) {
      // 判断无效/锁定/黑名单客户是否已经提交审批,如提交审批且有权限则跳转审批页面
      const approves = {
        lock: [ 'allow_lock', 'approval_lock_id'],
        invalid: [ 'allow_shift_invalid', 'approval_invalid_id'],
        blackList: ['allow_shift_black', 'approval_black_id']
      }
      let approveInfo = null;
      Object.keys(approves).map(v => {
        if (conditions?.operateType === v && !this.userInfo?.[approves[v]?.[0]] && this.userInfo?.[approves[v]?.[1]] !== 0) {
          approveInfo = {
            voucher_type: v === 'lock' ? 1 : v === 'invalid' ? 4 : 5,
            approvalId: this.userInfo?.[approves[v]?.[1]]
          }
        }
      })
      if (!approveInfo) {
        this.$EventBus.$emit(this.emitName, {category: typeName, params: {
          type: 'new',
          tabActiveName: this.activeName,
          customer_id: this.customerId,
          baseInfo: this.userInfo,
          ...conditions
        }});
      } else {
        // 跳转到审批页面
        this.$EventBus.$emit(this.emitName, {category: 'approve', params: {
          tabActiveName: this.activeName,
          ...approveInfo
        }});
      }
    },
    async getToggleList () {
      try {
        let res = '';
        if (this.condition.customeType === 'customeManager') {
          res = await getPrivateCustome(this.condition);
        } else if (this.condition.customeType === 'publicPool'){
          res = await myPublicCustomeList(this.condition);
        }
        this.toggleList = res.data ?? [];
        this.per_to = res.to;
        this.per_total = res.total;
      } catch (error) {
        this.toggleList = [];
      }
    },
    async handleSwitch (type) {
      const isNext = type === 'next';
      const index = isNext ? this.index + 1: this.index - 1;
      const next = this.toggleList[index];
      if (next) {
        this.customerId = next.id;
        this.index = index;
        await this.getCustomeById();
        this.$nextTick(_ => {
          this.$refs.detailJourneyRef.refreshData()
          this.$refs?.detailJourneyRef?.refrensh?.();
          this.$refs?.detailBaseRef?.refrensh?.();
          this.$refs?.detailBussiness?.refrensh?.();
          this.$refs?.detailOrder?.refrensh?.();
          this.$refs?.detailPreviewRef?.refrensh?.();
        })
      } else {
        this.condition.page = isNext ? this.condition.page + 1 : this.condition.page - 1;
        await this.getToggleList();
        this.index = isNext ? -1 : this.toggleList.length;
        await this.handleSwitch(type);
      }

    },
    async toggleVisitor (type) {
      if (type === 'prev' && this.isFirstPage()) return null;
      if (type === 'next' && this.isLastPage()) return null;
      this.loading = this.$loading({
        lock: true,
        text: '正在加载中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      await this.handleSwitch(type);
      this.loading.close();
      this.loading = null;
    },
    // 退出协助人
    outCustomHelper () {
      const _this = this;
      this.$confirm('退出协助人后原协助人将不能对该客户进行跟进，请谨慎操作！', '操作提示', {
        customClass: 'custom-tips-dialog',
        confirmButtonText: '退出',
        cancelButtonText: '取消'
      }).then(async _ => {
        try {
          await outCustomeHasHelper(_this.customerId);
          this.$message.success('协助人退出成功');
          // 关闭当前页并刷新客户列表
          this.cancel();
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
        }
      }).catch(e => {})
    },
    // 调用浏览记录更新内容
    handleUpdateRecord (data) {
      this.activeName = 'preview';
      this.$refs?.detailPreviewRef?.reload(data);
    },
    handleTabClick(tab){
      if(tab.name == 'preview'){
        this.$refs.detailPreviewRef.initial();
      }
    },
    handleQiangDistribe () {
      this.$confirm('确认领取该客户？', '操作提示', {
        customClass: 'custom-delete-dialog'
      }).then(async _ => {
        try {
          await guestTakeUser({
            customer_id: this.userInfo.id,
            csrf_token: this.userInfo.csrf_token
          });
          this.$message.success('抢客成功');
          this.cancel();
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
        }
      }).catch(e => {})
    }
  }
}
</script>
<style lang="less">
@import '~@/assets/style/detail.less';
.cus-detail-popover-style .popover-dialog.el-dialog .modify-container{
  overflow: visible;
}
</style>
